import axios from '@/axiosInterceptor';

const state = () => ({
  collection: [],
  pending_collection: [],
  pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  show: {},
  is_requests_loading: false,
});

const getters = {
  pendingRequestsCount: (state) => {
    const pendingConnections = state.collection.filter(
      (item) => item.status === 'pending'
    );
    if (!pendingConnections || pendingConnections.length < 1) return 0;
    return pendingConnections.length;
  },
};

// actions

const actions = {
  async getUserCompanyRequests(
    { commit },
    { query = '', page = 1, per_page = 50 }
  ) {
    commit('setRequestsLoading', true);

    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          `/api/v1/user_company_requests?page=${page}&per_page=${per_page}`,
        { q: query }
      );
      commit('setCollection', res.data);

      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      commit('setRequestsLoading', false);
    }
  },
  async getPendingUserCompanyRequests(
    { commit, state },
    { page = 1, per_page = 50, refetch = false }
  ) {
    if (!refetch) {
      commit('setRequestsLoading', true);
    }

    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          `/api/v1/user_company_requests?page=${page}&per_page=${per_page}&q[status_eq]=pending`
      );

      if (refetch) {
        const combinedUsers = [
          ...(state.pending_collection || []),
          ...res.data,
        ];

        commit('setPendingCollection', combinedUsers);
      } else {
        commit('setPendingCollection', res.data);
      }
      commit('setUserRequestsPagination', {
        totalRecords: res.headers?.totalitems,
        totalPages: res.headers?.totalpages,
        currentPage: res.headers?.currentpage,
      });

      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      commit('setRequestsLoading', false);
    }
  },
  async getUserCompanyRequest({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/user_company_requests/' + id
      );
      commit('setShow', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async approveUserCompanyRequest({ commit, state }, { id, scopes }) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/user_company_requests/' +
          id +
          '/approve',
        { scopes: scopes || ['onboarding'] }
      );
      let updatedCollection = state.collection.map((el) => {
        return el.id === res.data.id ? res.data : el;
      });
      commit('setCollection', updatedCollection);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async rejectUserCompanyRequest({ commit }, id) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/user_company_requests/' +
          id +
          '/reject'
      );
      commit('setShow', res.data);
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setCollection(state, data) {
    state.collection = data;
  },
  setPendingCollection(state, data) {
    state.pending_collection = data;
  },
  setShow(state, data) {
    state.show = data;
  },
  setUserRequestsPagination(state, data) {
    state.pagination = data;
  },
  setRequestsLoading(state, bool) {
    state.is_requests_loading = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
